export default {
  message: {
    Tour: {
      continue: "გაგრძელება",
      back: "უკან",
      finish: "დასრულება"
    },
    Login: {
      title: "მშობელთა შესვლა",
      sign_in: "შესვლა",
      login_fail:
        "ავთენტიფიკაცია ვერ მოხერხდა. გთხოვთ სცადოთ თავიდან ან დაუკავშირდეთ სკოლას დახმარებისთვის.",
      forgot_password: "დაგავიწყდათ პაროლი",
      create_account: "ანგარიშის შექმნა",
      password: "პაროლი",
      confirm_password: "დაადასტურეთ პაროლი",
      password_reminder: "პაროლის შეხსენება",
      enter_email: "შეიყვანეთ თქვენი ელფოსტის მისამართი",
      validation_error: "შემოწმების შეცდომის შეტყობინება",
      password_reminder_error_no_user_register:
        "მომხმარებელი ვერ მოიძებნა. გთხოვთ სცადოთ თავიდან ან შექმნათ ახალი ანგარიში.",
      password_reminder_error_no_user: "მომხმარებელი ვერ მოიძებნა.",
      password_reminder_sent: "დეტალური ინსტრუქციები გამოგზავნილია {email}-ზე.",
      password_reminder_sent_message:
        "წერილმა რამდენიმე წუთი შეიძლება დასჭირდეს ჩასასვლელად. თუ არ ჩანს შემოსულებში, შეამოწმეთ სპამის საქაღალდე.",
      password_trouble_email: "თუ პრობლემა გრძელდება, დაუკავშირდით {email}-ს.",
      password_trouble_school:
        "თუ პრობლემა გრძელდება, დაუკავშირდით სკოლას დახმარებისთვის.",
      return_to_sign_in: "უკან შესვლაზე",
      create_my_account: "ჩემი ანგარიშის შექმნა",
      or_sign_in_with: "ან შედით შემდეგით",
      password_reset: "გთხოვთ აირჩიოთ ახალი პაროლი თქვენი ანგარიშისთვის.",
      password_reset_warning:
        "თუ პაროლის შეცვლას არ მოითხოვეთ, დაუყოვნებლივ დაუკავშირდით სკოლის ადმინისტრატორს.",
      password_update: "აირჩიეთ ახალი პაროლი",
      password_update_confirm: "დაადასტურეთ ახალი პაროლი",
      password_update_success: "თქვენი ახალი პაროლი შენახულია."
    },
    AccountSettings: {
      title: "ანგარიშის პარამეტრები",
      first_name: "სახელი",
      last_name: "გვარი",
      email: "ელფოსტა",
      username: "მომხმარებლის სახელი",
      password: "პაროლი",
      students: "მოსწავლეები",
      teachers: "მასწავლებლები",
      external_id: "გარე ID",
      phone: "ტელეფონის ნომერი",
      phone_required: "ტელეფონის ნომერი აუცილებელია",
      edit: "რედაქტირება",
      remove: "წაშლა",
      add: "დამატება",
      remove_message: "ნამდვილად გსურთ ამ მოსწავლის წაშლა?",
      yes: "დიახ",
      no: "არა",
      add_student: "მოსწავლის დამატება",
      close: "დახურვა",
      save: "ცვლილებების შენახვა",
      cancel: "გაუქმება",
      student_alert_message: "უნდა შეიყვანოთ მინიმუმ ერთი მოსწავლე.",
      logout: "გასვლა"
    },
    Navbar: {
      my_meetings: "ჩემი შეხვედრები",
      language: "ქართული",
      help: "დახმარება",
      account_settings: "ანგარიშის პარამეტრები",
      user_management: "User Management",
      logout: "გასვლა"
    },
    SubNavbar: {
      meeting: "შეხვედრა",
      event: "ღონისძიება",
      print: "აღდაბეჭდვა",
      email: "ელფოსტა",
      export: "ექსპორტი"
    },
    ConferenceCard: {
      add_edit_meetings: "შეხვედრების დამატება/რედაქტირება",
      opening: "ღია",
      closed: "დახურული"
    },
    Agenda: {
      full_agenda: "სრული დღის წესრიგი",
      empty_state_title: "თქვენთვის კონფერენციები ვერ მოიძებნა.",
      empty_state_message: "კითხვების შემთხვევაში დაუკავშირდით სკოლის წარმომადგენელს.",
      confirmation_modal_title: "დღის წესრიგი დადასტურებულია",
      confirmation_modal_message:
        "თქვენი დღის წესრიგი წარმატებით დადასტურდა და ელფოსტით გამოგზავნილია.",
      complete_button: "დასრულება!"
    },
    AgendaCard: {
      room: "ოთახი მიუწვდომელია",
      room_with_value: "ოთახი: {room}",
      virtual_meeting: "ვირტუალური შეხვედრა",
      all_conferences: "ყველა კონფერენცია",
      conference: "კონფერენცია",
      student: "მოსწავლე",
      meeting_with: "შეხვედრა",
      date_time: "თარიღი/დრო",
      meeting_type: "შეხვედრის ტიპი",
      location: "ადგილმდებარეობა",
      comment: "კომენტარი",
      action: "მოქმედება",
      delete: "წაშლა",
      add_comment: "კომენტარის დამატება",
      join: "შეხვედრაზე დასწრება",
      choose_meeting_type: "აირჩიეთ შეხვედრის ტიპი",
      in_person: "პირადად",
      phone: "ტელეფონი",
      callback: "ზარის დაბრუნება",
      virtual: "ვირტუალური",
      hybrid: "ჰიბრიდული",
      unavailable: "მიუწვდომელია",
      tooltip_translator:
        "თარჯიმნის სერვისი არ გარანტირებულია, მაგრამ სკოლა ყველაფერს გააკეთებს მისი ხელმისაწვდომობისთვის.",
      translator_requested: "თარჯიმანი მოთხოვნილია",
      clear_translator: "თარჯიმნის მოთხოვნის გასუფთავება",
      need_translator: "გჭირდებათ თარჯიმანი?",
      choose_language: "აირჩიეთ ენა"
    },
    ScheduleMatrix: {
      no_teachers_title: "მასწავლებლები ან გუნდები არ არის არჩეული.",
      no_teachers_message: "შეხვედრის დროების სანახავად აირჩიეთ მასწავლებელი.",
      choose_teachers_button: "ხელმისაწვდომი მასწავლებლების ნახვა",
      choose_student: "რომელი მოსწავლისთვის?",
      cancel: "გაუქმება"
    },
    Matrix: {
      teachers: "მასწავლებლები",
      agenda: "შემოწმება და გაგრძელება"
    },
    DrawerTeachers: {
      teachers: "მასწავლებლები",
      name: "სახელი",
      description: "აღწერა",
      student: "მოსწავლე",
      teacher_team: "მასწავლებელი/გუნდი",
      show_more: "მეტი მასწავლებლის ჩვენება",
      show_all: "სკოლის ყველა მასწავლებლის ჩვენება",
      selected: "({count}) არჩეული",
      closeDrawer: "განრიგის გაგრძელება",
      search: "მასწავლებლის ან გუნდის ძებნა",
      not_available: "ამ მასწავლებელს {date}-ზე ხელმისაწვდომი დრო არ აქვს."
    },
    DrawerAgenda: {
      no_meetings_title: "შეხვედრები არ არის დაგეგმილი.",
      no_meetings_message: "მასწავლებლისა და დროის არჩევის შემდეგ შეხვედრა აქ გამოჩნდება.",
      new_meeting_label: "ახალი",
      cancel_button: "გაუქმება",
      student_label: "მოსწავლე",
      meeting_type_location: "შეხვედრის ტიპი/ადგილმდებარეობა",
      comment_label: "კომენტარი",
      save_comment_button: "კომენტარის შენახვა",
      confirm_label: "გთხოვთ დაადასტუროთ:",
      confirm_cancel_button: "დიახ, შეხვედრის გაუქმება ",
      do_not_cancel_button: "არ გაუქმება",
      confirm_agenda_button: "დღის წესრიგის დადასტურება",
      confirm_agenda_message_line1: "ყოველთვის შეგიძლიათ დაბრუნდეთ და შეცვალოთ.",
      confirm_agenda_message_line2: "მიმდინარე დღის წესრიგი ელფოსტით გამოგზავნილი იქნება."
    },
    EmailConsent: {
      message:
        "თქვენი კონფიდენციალურობისა და უსაფრთხოების დასაცავად, საჭიროა თქვენი თანხმობა სისტემიდან ელფოსტაზე შეტყობინებების მიღებაზე.",
      consent: "ვეთანხმები"
    },
    UserManagement: {
      pageTitle: "User Management",
      pageSubtitle:
        "Add and manage school and district staff accounts. Staff sign in with school or district login using this site's account.",
      addUser: "Add user",
      editUser: "Edit user",
      loading: "Loading users…",
      emptyTitle: "No staff users yet",
      emptyMessage: "Use Add user to create a school or district staff account.",
      tableUsername: "Username",
      tableEmail: "Email",
      tableRole: "Role",
      tableActions: "Actions",
      typeSchool: "School",
      typeDistrict: "District",
      roleTeam: "Team",
      roleSchool: "School Admin",
      roleReporter: "School Reporter",
      roleDistrict: "District Admin",
      roleNoIntegration: "School Admin without Integration",
      roleNotSet: "Role not set",
      roleUnknown: "Role ({id})",
      formUsername: "Username",
      formEmail: "Email",
      formPassword: "Password",
      formNewPassword: "New password (optional)",
      formRole: "Role",
      loginHint:
        "Staff sign in with the school portal. District staff may use the district portal subdomain when applicable.",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      confirmDeleteTitle: "Remove this user?",
      confirmDeleteBody:
        "This will remove the staff account from your school. This action cannot be undone.",
      validationRequired: "Please fill in all required fields.",
      createdSuccess: "User created.",
      updatedSuccess: "User updated.",
      deletedSuccess: "User removed.",
      genericError: "Something went wrong. Please try again.",
      changeRoleTitle: "Change role",
      roleUpdatedSuccess: "Role updated.",
      deleteUserAria: "Remove user",
      formSchool: "School",
      validationSchoolRequired: "Please select a school.",
      schoolListEmpty: "No schools are available in this district."
    },
    StudentsDirectory: {
      saveLinkHousehold: "Save link household",
      saveLinkHouseholdNothing: "No changes to save.",
      saveLinkHouseholdSuccess: "Link household updated for {count} students.",
      saveLinkHouseholdError: "Could not update link household.",
      saveLinkHouseholdPartial: "Updated {saved} students; {failed} could not be saved."
    }
  }
};
